/* ============================================================
   SHUBH LAABH — Divine Add to Cart Animation
   ============================================================ */
(function () {
  'use strict';

  const OM_PARTICLES = ['ॐ', '🌸', '✨', '🪷', '💫', 'ॐ'];

  function spawnOmParticle(x, y) {
    const el = document.createElement('span');
    el.className = 'sl-om-particle';
    el.textContent = OM_PARTICLES[Math.floor(Math.random() * OM_PARTICLES.length)];
    const angle = (Math.random() * 120 - 60) * Math.PI / 180;
    const dist = 60 + Math.random() * 60;
    el.style.left = x + 'px';
    el.style.top = y + 'px';
    el.style.setProperty('--tx', Math.sin(angle) * dist + 'px');
    el.style.setProperty('--ty', (-Math.cos(angle) * dist) + 'px');
    el.style.fontSize = (16 + Math.random() * 10) + 'px';
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 950);
  }

  function spawnCartFly(fromX, fromY) {
    const cartIcon = document.querySelector('.cart-bubble, .cart-btn, [href*="cart"]');
    if (!cartIcon) return;
    const toRect = cartIcon.getBoundingClientRect();
    const el = document.createElement('span');
    el.className = 'sl-cart-fly-icon';
    el.textContent = '🛒';
    el.style.left = fromX + 'px';
    el.style.top = fromY + 'px';
    const dx = toRect.left - fromX;
    const dy = toRect.top - fromY;
    el.style.setProperty('--tx', dx + 'px');
    el.style.setProperty('--ty', dy + 'px');
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 850);
  }

  function doAddToCartEffect(btn) {
    const rect = btn.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;

    // Pulse button
    btn.classList.add('sl-success');
    const card = btn.closest('.sl-prod-card, .sl-product-atc, product-form, form[action*="cart"]');
    if (card) card.classList.add('sl-atc-animating');

    // Spawn OM particles
    for (let i = 0; i < 4; i++) {
      setTimeout(() => spawnOmParticle(cx + Math.random() * 40 - 20, cy + Math.random() * 20 - 10), i * 80);
    }

    // Fly to cart
    setTimeout(() => spawnCartFly(cx, cy), 100);

    // Change button text temporarily
    const origText = btn.textContent.trim();
    if (btn.tagName !== 'BUTTON' || btn.name !== 'add') {
      btn.textContent = '🙏 Added!';
      setTimeout(() => {
        btn.textContent = origText;
        btn.classList.remove('sl-success');
        if (card) card.classList.remove('sl-atc-animating');
      }, 2200);
    } else {
      setTimeout(() => {
        btn.classList.remove('sl-success');
        if (card) card.classList.remove('sl-atc-animating');
      }, 2200);
    }
  }

  // Hook into Shopify's product form submit
  document.addEventListener('click', function (e) {
    // Manual add-btn clicks (non-form product cards)
    const addBtn = e.target.closest('.sl-add-btn');
    if (addBtn) {
      doAddToCartEffect(addBtn);
      return;
    }
  }, true);

  // Hook into Shopify's add-to-cart button  
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="cart/add"], product-form form');
    if (!form) return;
    const btn = form.querySelector('button[name="add"], .add-to-cart-button, #AddToCart');
    if (btn) {
      const rect = btn.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      for (let i = 0; i < 5; i++) {
        setTimeout(() => spawnOmParticle(cx + Math.random() * 60 - 30, cy + Math.random() * 30 - 15), i * 70);
      }
      setTimeout(() => spawnCartFly(cx, cy), 120);
      btn.classList.add('sl-success');
      setTimeout(() => btn.classList.remove('sl-success'), 2200);
    }
  }, true);

  // Hook into Shopify custom event (add-to-cart-component)
  document.addEventListener('on:cart:add', function (e) {
    const btn = document.querySelector('[ref="addToCartButton"]');
    if (btn) {
      const rect = btn.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      for (let i = 0; i < 5; i++) {
        setTimeout(() => spawnOmParticle(cx + Math.random() * 70 - 35, cy + Math.random() * 30 - 15), i * 75);
      }
    }
  });

})();
